import { usePsfPromoteOrSharePageData } from '#src/app/pages/psf/promoteOrShare/pageContext';
import { useShareActions } from '#src/app/shared/hooks/share';

import { useShareOptions } from './options';

export function usePsfShareAvailableShareActions() {
	const options = useShareOptions();
	const {
		data: {
			petition: { shareLinks },
		},
	} = usePsfPromoteOrSharePageData();

	return useShareActions(shareLinks.links, options);
}
